/**************************************************
 * Nombre:       Tarjeta_Banner
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {NEGRITA} from "../../Constantes";
import {KeyboardArrowRight} from '@mui/icons-material'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../Dialogos/Dialogo_Wass";
import {irUrl} from "../../Utilidades/irUrl";


const Tarjeta_Banner = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Iniciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 1 : 3, color: '#ffffff', height: masSM ? 'auto' : 940}}
                spacing={6}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: !masSM ? 16 : 0}}>
                            <Typography
                                sx={{
                                    fontSize: !masSM ? 14 : 18,
                                    fontWeight: 700,
                                    color: '#00d5f1',
                                    textAlign: sCell ? 'center' : 'left'
                                }}>Anuncio</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: !masSM ? 42 : 56,
                                    fontWeight: 400,
                                    color: '#ffffff',
                                    lineHeight: 1,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>{item.titulo}</Typography>
                        </Grid>

                        {item.subtitulo &&

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                                <Typography
                                    sx={{
                                        color: '#00d5f1',
                                        fontFamily: NEGRITA,
                                        fontSize: !masSM ? 30 : 38,
                                        fontWeight: 400,
                                        lineHeight: 1,
                                        textAlign: sCell ? 'center' : 'left'
                                    }}>{item.subtitulo}</Typography>
                            </Grid>
                        }

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2}}>
                            <Typography sx={{
                                fontSize: !masSM ? 18 : 20,
                                fontWeight: 400,
                                color: '#fff',
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                {item.descripcion}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4, mb: sCell ? 2 : 18}}>
                            {item.textoBoton &&
                                <Button
                                    onClick={() => {
                                        if (item.formulario) {
                                            abrir({asunto: item.titulo + ' ' + item.subtitulo})
                                        } else {
                                            irUrl(item.link)
                                        }
                                    }}
                                    color={'secondary'} sx={{py: 0.8}}
                                    startIcon={<KeyboardArrowRight/>}
                                >
                                    {item.textoBoton}
                                </Button>
                            }
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'center', mt: sCell ? 0 : 16}}>
                    <img src={item.img} width={!masSM ? '100%' : '90%'} height={'auto'}/>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Banner    